var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "modal-container" }, [
      _c("div", { staticClass: "modal-header" }, [
        _vm._v(
          "\n            " +
            _vm._s(_vm.action) +
            " " +
            _vm._s(_vm.arr[0] == "slink" ? " Slink" : " Subslink Pack") +
            "\n            "
        ),
        _c("div", {
          staticClass: "delete is-large is-pulled-right",
          on: { click: _vm.doClose }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-body has-text-dark" }, [
        _c("form", [
          _c("div", { staticClass: "is-size-3 left10" }, [
            _c(
              "span",
              {
                staticClass: "chevrons has-text-grey-light has-text-weight-bold"
              },
              [_vm._v("»")]
            ),
            _c("span", { staticClass: "has-text-dark" }, [
              _vm._v(_vm._s(_vm.slink))
            ]),
            _vm.arr[0] == "pack" && _vm.arr[1] != "add"
              ? _c("span", { staticClass: "has-text-grey" }, [
                  _vm._v(" - Pack " + _vm._s(_vm.pack))
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          this.arr[1] == "remove" && _vm.arr[0] == "slink"
            ? _c("div", { staticClass: "top20 left10" }, [
                _vm._v("\n                    The slink "),
                _c("span", { staticClass: "has-text-weight-bold" }, [
                  _vm._v('"' + _vm._s(_vm.slink) + '"')
                ]),
                _vm._v(
                  " will be removed from your subscription.  It will, however, remain active until its\n                    renewal date, but will not be billed or renewed on that date.\n                "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          this.arr[1] == "reinstate" && _vm.arr[0] == "slink"
            ? _c("div", { staticClass: "top20 left10" }, [
                _vm._v("\n                    This slink "),
                _c("span", { staticClass: "has-text-weight-bold" }, [
                  _vm._v('"' + _vm._s(_vm.slink) + '"')
                ]),
                _vm._v(
                  "  will be added back to your subscription.  It will be billed on its renewal date.\n                "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          this.arr[1] == "add" && _vm.arr[0] == "pack"
            ? _c("div", { staticClass: "top20 left10" }, [
                _vm._v(
                  "\n                    A subslink pack will be added to your cart. Once you have completed the checkout process, it will be available on this manage page (slink "
                ),
                _c("span", { staticClass: "has-text-weight-bold" }, [
                  _vm._v('"' + _vm._s(_vm.slink) + '")')
                ]),
                _vm._v(
                  ".\n                    You can then configure your new subslinks.\n                "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          this.arr[1] == "remove" && _vm.arr[0] == "pack"
            ? _c("div", { staticClass: "top20 left10" }, [
                _vm._v(
                  "\n                    This subslink pack will be removed from your subscription. It will, however, remain active until its\n                    renewal date, but will not be billed or renewed on that date.\n                "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          this.arr[1] == "reinstate" && _vm.arr[0] == "pack"
            ? _c("div", { staticClass: "top20 left10" }, [
                _vm._v(
                  "\n                    This subslink pack will be added back to your subscription.  It will be billed and renewed on its renewal date.\n                "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "top20 left10" }, [
            _c(
              "button",
              {
                staticClass: "button is-warning",
                attrs: { type: "submit" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.save.apply(null, arguments)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.action.toUpperCase()))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button left10",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.doClose.apply(null, arguments)
                  }
                }
              },
              [_vm._v("CANCEL")]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._m(0)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-footer" }, [_c("div")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dedfc202", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dedfc202","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalAddRemPack.vue
// module id = null
// module chunks = 